import { render, staticRenderFns } from "./ArrowSignIcon.vue?vue&type=template&id=708c463e&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c463e",
  null
  
)

export default component.exports